import React from "react";
import { makeStyles } from "@material-ui/styles";
import { createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    loadingWrapper: {
      width: "200px",
      height: "60px",
      position: "absolute",
      left: "50%",
      top: "43%",
      transform: "translate(-50%, -50%)"
    },
    loadingCircle: {
      width: "20px",
      height: "20px",
      position: "absolute",
      borderRadius: "50%",
      backgroundColor: "rgb(226, 0, 116)",
      left: "15%",
      transformOrigin: "50%",
      animation: `$circleAnime 0.5s alternate infinite ease`,
      "&:nth-child(2)": {
        left: "45%",
        animationDelay: "0.2s"
      },
      "&:nth-child(3)": {
        left: "auto",
        right: "15%",
        animationDelay: "0.3s"
      }
    },
    "@keyframes circleAnime": {
      "0%": {
        top: "60px",
        height: "5px",
        borderRadius: "50px 50px 25px 25px",
        transform: "scaleX(1.7)"
      },
      "40%": {
        height: "20px",
        borderRadius: "50%",
        transform: "scaleX(1)"
      },
      "100%": {
        top: "0%"
      }
    },
    loadingShadow: {
      width: "20px",
      height: "4px",
      borderRadius: "50%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      position: "absolute",
      top: "62px",
      transformOrigin: "50%",
      zIndex: -1,
      left: "15%",
      filter: "blur(1px)",
      animation: `$shadowAnime 0.5s alternate infinite ease`,
      "&:nth-child(4)": {
        left: "45%",
        animationDelay: "0.2s"
      },
      "&:nth-child(5)": {
        left: "auto",
        right: "15%",
        animationDelay: "0.3s"
      }
    },
    "@keyframes shadowAnime": {
      "0%": {
        transform: "scaleX(1.5)"
      },
      "40%": {
        transform: "scaleX(1)",
        opacity: 0.7
      },
      "100%": {
        transform: "scaleX(0.2)",
        opacity: 0.4
      }
    },
    loadingText: {
      position: "absolute",
      top: "75px",
      fontFamily: "Roboto",
      fontSize: "20px",
      letterSpacing: "12px",
      color: "rgb(226, 0, 116)",
      left: "15%"
    }
  });
});

// todo possibly extend of FunctionalComponent with options
const LoadingComponent = () => {
  const styles = useStyles();

  return (
    <div className={styles.loadingWrapper}>
      <div className={styles.loadingCircle} />
      <div className={styles.loadingCircle} />
      <div className={styles.loadingCircle} />
      <div className={styles.loadingShadow} />
      <div className={styles.loadingShadow} />
      <div className={styles.loadingShadow} />
      <span className={styles.loadingText}>Loading</span>
    </div>
  );
};

export const Loader = LoadingComponent;
